import BaseService from './base.service';

class ContactMessagesService extends BaseService {
    constructor() {
        super('/api/v2/public/contact-messages');
    }

    sendEmail(data) {
        return this.post('', data);
    }
}

export default new ContactMessagesService();
